import { createSignal, For, Show } from "solid-js";
import { KEYBOARD_SCOPE } from "../../enums/shell";
import { comboForDisplay } from "../../keyboard/boundaries/combo.formatter";
import { setScope } from "../../keyboard/manager";
import { allBindings, registerBinding } from "../../keyboard/registry";

const [open, setOpen] = createSignal(false);

export function registerCheatSheetBinding(): void {
  registerBinding({
    combo: "?",
    scope: KEYBOARD_SCOPE.GLOBAL,
    describe: "Show keyboard shortcuts",
    run: () => {
      setOpen(true);
      setScope(KEYBOARD_SCOPE.PALETTE);
    },
  });
}

export function CheatSheetHost() {
  const close = () => {
    setOpen(false);
    setScope(KEYBOARD_SCOPE.LIST);
  };

  return (
    <Show when={open()}>
      <div class="cheat-scrim">
        <div class="cheat card">
          <button
            class="icon-btn cheat-close"
            type="button"
            aria-label="Close shortcuts"
            onClick={close}
          >
            ✕
          </button>
          <h3>Keyboard shortcuts</h3>
          <For each={allBindings()}>
            {(binding) => (
              <div class="cheat-row">
                <span>{binding.describe}</span>
                <kbd>{comboForDisplay(binding.combo)}</kbd>
              </div>
            )}
          </For>
        </div>
      </div>
    </Show>
  );
}
